import { useCallback, useState } from 'react';
import { titleRepositorySingleton } from '@warehouse/title/infra';
import { useSnackbar } from 'notistack';

export function useExportTitle() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | undefined>(undefined);
	const titleRepository = titleRepositorySingleton.get();
	const [data, setData] = useState<string | undefined>(undefined);
	const { enqueueSnackbar } = useSnackbar();

	const loadExport = useCallback(
		async (uuid: string, type: 'xml' | 'json') => {
			setData(undefined);
			setLoading(true);
			setError(undefined);
			try {
				const mec = await titleRepository.exportTitleMEC({
					uuid,
					type,
				});
				setData(mec);
			} catch (err: any) {
				setError(err);
				enqueueSnackbar(err.message || 'Failed to export MEC', {
					variant: 'error',
					autoHideDuration: 2000,
				});
			} finally {
				setLoading(false);
			}
		},
		[enqueueSnackbar, titleRepository],
	);

	const clear = useCallback(() => {
		setData(undefined);
		setError(undefined);
		setLoading(false);
	}, []);

	return { loadExport, data, loading, error, clear };
}
